export default __webpack_public_path__ + "./images/lr.fbda01ba.png";